<script lang="ts">
    import { errorStore } from '$src/infrastructure/defaults/errorStore';
    import { get } from 'svelte/store';
  
    let errorInstance: Error | null = get(errorStore);
</script>

<h1>Une erreur s'est produite</h1>
<p>{errorInstance?.cause}</p>
<p>{errorInstance?.name}</p>
<p>{errorInstance?.message}</p>
<p>{errorInstance?.stack}</p>
